import { LoginScreen } from '@/features/auth/LoginScreen';
import { ensureSession, returnTarget } from '@/lib/session';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

export const Route = createFileRoute('/login')({
  staticData: { public: true },
  validateSearch: z.object({ returnTo: z.string().optional() }),
  // A session opening /login goes to returnTo, else / (merchant screens §3.1 Log in).
  beforeLoad: async ({ context, search }) => {
    if (await ensureSession(context)) throw redirect(returnTarget(search.returnTo));
  },
  component: LoginScreen,
});
